import { UserMemo, UserMemoFromJSON, UserNote, UserNoteFromJSON } from '@/api'

export interface UserOfMemosAndNote {
  memos: UserMemo[]
  notes: UserNote[]
}

export function UserOfMemosAndNoteFromJSON(json: any): UserOfMemosAndNote {
  if (json === undefined || json === null) {
    return json
  }
  return {
    memos: json.memos.map(UserMemoFromJSON),
    notes: json.notes.map(UserNoteFromJSON)
  }
}
